import React, { useState } from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PdfViewerModal from './PdfViewerModal';

const Footer: React.FC = () => {
  const [pdfModal, setPdfModal] = useState<{ open: boolean; url: string; title: string }>({
    open: false,
    url: '',
    title: ''
  });

  const handleOpenPdf = (url: string, title: string) => {
    setPdfModal({ open: true, url, title });
  };

  const handleClosePdf = () => {
    setPdfModal({ open: false, url: '', title: '' });
  };
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <EmailIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              Need help?
            </Typography>
            <Link
              href="mailto:support@mentoringfusion.com"
              underline="hover"
              sx={{ color: 'primary.main', fontWeight: 500 }}
            >
              Contact support
            </Link>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
            •
          </Typography>

          <Link
            component="button"
            onClick={() => handleOpenPdf(`${process.env.PUBLIC_URL}/MentoringFusion_Admin_Terms.pdf`, 'Terms & Conditions')}
            underline="hover"
            sx={{ 
              color: 'primary.main', 
              fontWeight: 500,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }}
          >
            <Typography variant="body2">
              Terms & Conditions
            </Typography>
          </Link>

          <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
            •
          </Typography>

          <Link
            component="button"
            onClick={() => handleOpenPdf(`${process.env.PUBLIC_URL}/Privacy_and_Data_Notice.pdf`, 'Privacy & Data Notice')}
            underline="hover"
            sx={{ 
              color: 'primary.main', 
              fontWeight: 500,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }}
          >
            <Typography variant="body2">
              Privacy & Data Notice
            </Typography>
          </Link>
        </Box>
      </Container>

      {/* PDF Viewer Modal */}
      <PdfViewerModal
        open={pdfModal.open}
        onClose={handleClosePdf}
        pdfUrl={pdfModal.url}
        title={pdfModal.title}
      />
    </Box>
  );
};

export default Footer;
